export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
    {
      title: "Edit",
      cls: "bulk-edit-location",
      icon: "pencil",
      disabled:true
    },
    {
      title: "Delete",
      cls: "bulk-delete-location",
      icon: "trash",
      disabled:false
    }
  ],
  "actions": [
    {
      title: "Edit",
      cls: "edit-location",
      icon: "pencil",
      disabled:false
    },
    {
      title: "Delete",
      cls: "delete-location",
      icon: "trash",
      disabled:false
    }
  ]
};


// WEBPACK FOOTER //
// ./src/pages/locationMapping/filter/actionOptions.js